const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'low-perceived-stress',
        conditions: [{ id: 'score', min: 0, max: 13, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    },
    {
        id: 'moderate-perceived-stress',
        conditions: [{ id: 'score', min: 14, max: 26, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    },
    {
        id: 'high-perceived-stress',
        conditions: [{ id: 'score', min: 27, max: 40, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    }
]);